// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Kgsp___Amenities-module__container","amenity-row":"_3r3Ae___Amenities-module__amenity-row"};